import React, { memo } from 'react';
import styles from './button.module.scss';
import ThreeDotsSpinner from '../ThreeDotsSpinner';
import OvalSpinner from '../OvalSpinner';
const Button = ({ className, onClick, children, secondButton = false, loading = false, disabled, specialButton = false, iconButton = false, sendButton = false, label, flexStart, grayIcon=true }) => {
    if (!loading) {
        return (
            <div className={`${className} ${flexStart? styles.flexStart : styles.content}`}>
                < button className={` ${label? styles.buttonWithLabel : styles.button} ${secondButton && styles.secondButton} ${specialButton && styles.specialButton} ${grayIcon && styles.iconButton} ${sendButton && styles.sendButton}`} onClick={onClick} disabled={disabled}>
                    {children}
                </button >
            </div>
        );
    } else {
        return (
            <div className={`${className} ${flexStart? styles.flexStart : styles.content} `}>
                < button className={`${label? styles.buttonWithLabel : styles.button} ${styles.loading} ${secondButton && styles.secondButton} ${specialButton && styles.specialButton} ${styles.iconButton} ${sendButton && styles.sendButton}`} disabled={disabled}>
                    {iconButton ? <ThreeDotsSpinner color={'#157AD6'}/> : <OvalSpinner color='#7a7a7a' secondaryColor='4D4A4A'/>}
                </button >
            </div>

        );
    }
}

export default memo(Button);